import type { EssayReportBodyComposition } from './schemas'

/***************** 보고서 본문 구성 *****************/
export const ESSAY_REPORT_BODY_COMPOSITION_LABEL = {
  SUMMARY: { title: '요약형', description: '유형별 점수 · 총평' },
  FEEDBACK_SCORE: { title: '표준형', description: '요약형 + 문항별 점수 · 첨삭' },
  PROBLEM_FEEDBACK_SCORE: { title: '상세형', description: '표준형 + 문제' },
} as const satisfies Record<EssayReportBodyComposition, { title: string; description: string }>

/***************** 글자 수 상한 *****************/
/** 보고서 총평 최대 글자 수 (공백 포함). 넘으면 서버가 400 으로 거부한다 */
export const ESSAY_REPORT_COMMENT_MAX_LENGTH = 650
